import MetalUImage from "@/images/metal_u@2x.png";
import MetalAOImage from "@/images/metal_ao@2x.png";

export default [
  {
    shape: "元寶",
    name: "雙龍元寶",
    code: "U",
    imagePath: MetalUImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 5,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 9,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "元寶",
    name: "福運元寶",
    code: "AO",
    imagePath: MetalAOImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 5,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 9,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 5,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
];
